import request from '@/services/base/request';
import ServicesEnum from '@/services/_helpers/_types';
export default {
    loadNotifications: (data) => request(ServicesEnum.passport, '/notifications/' + data.query, 'get', data.payload),
    readNotification: (data) => request(ServicesEnum.passport, `/notifications/${data.notificationId}/`, 'post', data.payload)
};
